import { Alert, Button, Checkbox, Space, Spin } from 'antd';
import { StyledTaskStudentsEditor } from './TaskStudentsEditor.styled';
import useTaskStudentsEditor from './useTaskStudentsEditor.hook';

export default function TaskStudentsEditor({
  taskId,
  classId,
  selectedStudents,
  setSelectedStudents,
}) {
  const { state, actions } = useTaskStudentsEditor({
    taskId,
    classId,
    selectedStudents,
    setSelectedStudents,
  });
  return (
    <StyledTaskStudentsEditor>
      <Spin spinning={state.loading}>
        <div className="students-container">
          <p>Choose students:</p>
          <Space className="mb">
            <Button
              onClick={actions.selectAllStudents}
              disabled={state.classStudents.length == selectedStudents.length}
            >
              Select all
            </Button>
            <Button
              onClick={actions.unselectAllStudents}
              disabled={!selectedStudents.length}
            >
              Unselect all
            </Button>
          </Space>
          <div className="students">
            {state.classStudents.length ? (
              state.classStudents.map((student) => (
                <div key={student.id} className="student">
                  <Checkbox
                    checked={selectedStudents.find(
                      (selectedStudent) => selectedStudent.id == student.id
                    )}
                    onChange={(e) =>
                      e.target.checked
                        ? actions.onStudentAdded(student)
                        : actions.onStudentRemoved(student)
                    }
                  >
                    <span>
                      {student.firstName} {student.lastName}
                    </span>
                  </Checkbox>
                </div>
              ))
            ) : (
              <Alert description="There aren't students in this class" />
            )}
          </div>
        </div>
      </Spin>
    </StyledTaskStudentsEditor>
  );
}
